import "./polyfill";
import "./Debug";

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "./i18n";

import "@bd-styles/style.scss";

import { TotalTeamPlayedProvider } from "./contexts/TotalTeamPlayedContext";
import { BrowserRouter } from "react-router-dom";

import { createRoot } from "react-dom/client";

// If parent location is different => this site is inside an iframe
const IS_INSIDE_IFRAME = window.location !== window.parent.location;
const rootElement = document.getElementById("root");
const container = createRoot(rootElement);

if (IS_INSIDE_IFRAME && rootElement) rootElement.classList.add("is-iframe");

container.render(
  <BrowserRouter>
    <TotalTeamPlayedProvider>
      <App isIframe={IS_INSIDE_IFRAME} />
    </TotalTeamPlayedProvider>
  </BrowserRouter>
);
